import { useMemo } from 'react';
// import { MenuItemVariantDto } from '../../generated-api';
import { useAllMenuSections, useMenuComponentProducts } from '../context/MenuSectionsStore';
import { MenuItemVariantDto } from 'generated-api';
// import { MenuItemVariantDto } from 'generated-api';

/**
 * Hook to get all available products (from menu sections + component products)
 * Centralizes the logic for combining both sources
 */
export function useAllProducts(): MenuItemVariantDto[] {
  const allMenuSections = useAllMenuSections();
  const componentProducts = useMenuComponentProducts();

  return useMemo(() => {
    const flatSectionProducts = allMenuSections.flatMap((section) => [
      ...section.items,
      ...section.subsections.flatMap((sub) => sub.items),
    ]);
    return [...flatSectionProducts, ...componentProducts];
  }, [allMenuSections, componentProducts]);
}
